import { Routes } from '@angular/router';

import historyRouteData from './components/history/route-data';
import homeRouteData from './components/home/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/home/home.component'),
    data: homeRouteData
  },
  {
    path: 'history',
    loadComponent: async () => import('./components/history/history.component'),
    data: historyRouteData
  },
  {
    path: 'history/:id',
    loadComponent: async () => import('./components/game/game.component')
  }
];
